// Asking the engine for an exercise the person brought in — a swap or an
// add, before the start or during the session (W3) — so it gets the
// numbers next/ would have given it today (history, seeds, D7–D9), not
// ones made up here. Kept out of the component files (react-refresh); the
// callers own the guards (newest pick wins, nothing lands after unmount)
// and the fallback when this rejects (planEdit.itemFor, `failed`).
import { trainingApi } from "../../../services/api";
import { planItemIn } from "./logSet";

/**
 * POST prescribe/ for one exercise with the day's check-in (the draft's
 * before the start, the session's during it). Resolves to `{item, notices}`:
 * the engine's TrainingPlanItem with its load in `units` (the plan's), and
 * what it says about doing it today (a painful joint, missing equipment).
 * Rejects when there's no answer, or no item for the exercise in it.
 */
export async function askEngine(exercise, { checkin = null, units, settings } = {}) {
  const { data } = await trainingApi.prescribe({
    exercises: [exercise.key],
    ...(checkin ? { checkin } : {}),
  });
  const found = (data?.items ?? []).find((item) => item.exercise === exercise.key);
  if (!found) throw new Error(`prescribe/ answered no item for ${exercise.key}`);
  return {
    item: planItemIn(found, data.units, units, exercise, settings),
    notices: data.notices ?? [],
  };
}
